import { render, staticRenderFns } from "./WineryDashboardFormModal.vue?vue&type=template&id=b95ce20c&scoped=true"
import script from "./WineryDashboardFormModal.vue?vue&type=script&lang=js"
export * from "./WineryDashboardFormModal.vue?vue&type=script&lang=js"
import style0 from "./WineryDashboardFormModal.vue?vue&type=style&index=0&id=b95ce20c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95ce20c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b95ce20c')) {
      api.createRecord('b95ce20c', component.options)
    } else {
      api.reload('b95ce20c', component.options)
    }
    module.hot.accept("./WineryDashboardFormModal.vue?vue&type=template&id=b95ce20c&scoped=true", function () {
      api.rerender('b95ce20c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/public-dashboards/wineries/WineryDashboardFormModal.vue"
export default component.exports